import PropTypes from 'prop-types';

import React, { Component } from 'react';
import $j from 'jquery';
import AudioCardPlayer from '../../../../components/AudioCardPlayer';

export default class HTMLCardDark extends Component {
  static propTypes = {
    cardId: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    // this.parseHtmlContent();
  }

  state = {
    narrationOn: true,
    showAndPlayAudio: false
  };

  componentDidMount() {
    window.eval(
      `
        function imageLoadedNew(){
          imageLoaded();
          var imgContainer = document.querySelector('.imgContainer');
          imgContainer && imgContainer.setAttribute('style','');
        }
      `
    );
    this.parseHtmlContent();
    this.setState({});
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.cardId !== nextProps.cardId) {
      this.parseHtmlContent();
    }

    if (nextProps.showNarration === true && this.props.showNarration === false) {
      this.setState({ showAndPlayAudio: true });
      // console.log('should Be False',this.state.showAndPlayAudio);
      this.state.showAndPlayAudio = false;
    }
  }

  getHTMLObject() {
    return {
      __html: this.htmlContent
    };
  }

  parseHtmlContent() {
    this.htmlContent = this.props.card.htmlContent;
    // This code manually removes the script tag from html data
    // and puts it into global window context using window.eval.
    // The aspectRatio is taken from the string of html and
    // style tag of div is replaced to have appropriate min-width
    // and min-height.
    // const scriptContentArray = /<script type=text\/javascript>(.*?)<\/script>/gi.exec(this.htmlContent);
    const scriptRegEx = /<script type=text\/javascript>(.*?)<\/script>/gi;
    const scriptContentToReplaceFromHTML = [];
    let scriptContentArray;
    scriptContentArray = scriptRegEx.exec(this.htmlContent);
    // console.log('scriptContentArray 11:: ', scriptContentArray, scriptRegEx.lastIndex);

    while (scriptContentArray !== null) {
      // var msg = 'Found ' + myArray[0] + '. ';
      // console.log('scriptContentArray:: ', scriptContentArray, scriptRegEx.lastIndex);
      // scriptToBeExec += tempStore[1];

      if (scriptContentArray && scriptContentArray.length > 0) {
        const scriptContent = scriptContentArray[0];
        // this.htmlContent = this.htmlContent.replace(scriptContent, '');
        scriptContentToReplaceFromHTML.push(scriptContent);

        window.eval(scriptContentArray[1]);
        // console.log('executed:: ', scriptContentArray[1]);

        const aspectRatioArray = /var aspectRatio=(.*?);/gi.exec(scriptContent);
        // const aspectRatioArray = 0.8278867102;
        const aspectRatio =
          aspectRatioArray && aspectRatioArray.length === 2 ? parseFloat(aspectRatioArray[1]) : 0;
        // let imageWidth = document.body.clientWidth;
        let imageWidth = $j('.HtmlContentWrapper').width() || document.body.offsetWidth;
        // imageWidth = imageWidth > 600 ? 600 : imageWidth;
        let imageHeight = imageWidth * aspectRatio;
        imageWidth = 'min-width:' + imageWidth + 'px;';
        imageHeight = 'min-height:' + imageHeight + 'px;';
        const styleTag = 'style=' + imageWidth + imageHeight;
        this.htmlContent = this.htmlContent.replace(
          '<div class="loading imgContainer">',
          '<div class="loading imgContainer" ' + styleTag + '>'
        );
        this.htmlContent = this.htmlContent
          .replace('.loading', '.loadingImageContainer')
          .replace('class="loading', 'class="loadingImageContainer');
        this.htmlContent = this.htmlContent.replace('=imageLoaded()', '=imageLoadedNew()');
      }
      scriptContentArray = scriptRegEx.exec(this.htmlContent);
      // console.log('scriptContentArray 22:: ', scriptContentArray, scriptRegEx.lastIndex);
    }
    if (scriptContentToReplaceFromHTML.length > 0) {
      scriptContentToReplaceFromHTML.map(scriptTag => {
        this.htmlContent = this.htmlContent.replace(scriptTag, '');
      });
    }
    this.htmlContent =
      this.htmlContent && this.htmlContent.replace(/Roboto-Regular/g, 'ProximaNova');
  }

  render() {
    // console.log('HTML CARD');
    this.parseHtmlContent();
    // console.log(this.htmlContent);
    return (
      <div
        className="HtmlContentWrapper"
        style={styles.container}
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <div dangerouslySetInnerHTML={this.getHTMLObject()} />
        {this.props.showNarration ? (
          <AudioCardPlayer
            ref="audioPlayer"
            card={null}
            playAfterShow={this.state.showAndPlayAudio}
            url={this.props.narrationUrl}
            container={styles.audioContainer}
            showControls={true}
            narrationAudio={true}
          />
        ) : null}
      </div>
    );
  }
}

const styles = {
  container: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
    padding: '40px',
    boxSizing: 'border-box',
    backgroundColor: '#fff'
  },
  audioContainer: {
    width: 'auto',
    alignSelf: 'center'
  }
};
